import { Node } from "@xyflow/react";

/**
 * Adjusts the position of a node to be relative to its parent group node.
 */
export const getNodePositionInsideParent = (
  node: Partial<Node>,
  groupNode: Node,
) => {
  const position = node.position ?? { x: 0, y: 0 };

  // Convert the node's position to be relative to the group's position
  position.x = position.x - groupNode.position.x;
  position.y = position.y - groupNode.position.y;

  return position;
};
